<template>
  <div>
    <table class="ranking">
      <tr class="center" :style="storeType === 'appStore' ? 'background-color: #dce7f1;border: 1px solid #dce7f1;': 'background-color: #e1ebd6;border: 1px solid #e1ebd6;'">
        <td class="center region-key">{{ regionKey.toUpperCase() }}</td>
        <td class="center" colspan="2">{{ storeType === 'appStore' ? 'App Store' : 'Google Play' }}</td>
      </tr>
      <tr class="center rank-header">
        <td class="rank-cell">#</td>
        <td class="rank-cell">Free</td>
        <td class="rank-cell">Grossing</td>
      </tr>
      <tr v-for="rank in 10" :key="rank">
        <td class="center rank-cell">{{ rank }}</td>
        <app-info :info="ranking['free'][rank-1]" />
        <app-info :info="ranking['grossing'][rank-1]" />
      </tr>
    </table>
  </div>
</template>

<script>
import AppInfo from './AppInfo.vue';

export default {
  name: 'Ranking',
  components: {
    AppInfo,
  },
  props: ['ranking', 'regionKey', 'storeType'],
}
</script>

<style scoped>
.ranking {
  margin: 20px 0px;
  border-collapse: collapse;
}

.center {
  text-align: center;
  vertical-align: middle;
}

.region-key {
  width: 30px;
}

.rank-header {
  background-color: #eee;
}

.rank-cell {
  border: 1px solid #ccc;
  text-align: center;
  border-spacing: 0;
}
</style>
